export default {
  props: {
    modelValue: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    black: Boolean,
  },
  emits: ['toggle', 'update:modelValue'],
  watch: {
    modelValue(val) {
      this.isChecked = val;
    },
  },
  data() {
    return {
      isChecked: this.modelValue,
    };
  },
  computed: {
    isOnModifier() {
      return {
        'switch-button--on': this.isChecked,
        'switch-button--disabled': this.disabled,
        'switch-button--black': this.black,
      };
    },
  },
  methods: {
    toggle() {
      if (!this.disabled) {
        this.isChecked = !this.isChecked;
        this.$emit('toggle', this.isChecked);
        this.$emit('update:modelValue', this.isChecked);
      }
    },
  },
};
